import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/index.css'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import VueAwesomeSwiper from "vue-awesome-swiper"; //平移轮播
Vue.use(VueAwesomeSwiper)

import element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(element)


Vue.config.productionTip = false

import AXIOS from 'axios'
Vue.prototype.$axios = AXIOS
Vue.prototype.$apiBaseUrl = 'http://39.96.28.56:5000';
let url = "http://gatewayapi.hbbytzn.com";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
